import * as styles from "../index.module.scss";
import {
  ApiResponse,
  FormCustomBusinessProps,
  FormResponse,
  FormSME,
  FormTOP,
  ReactHookFormSME,
  ReactHookFormTOP,
} from "../types";
import { Button } from "@wise-emotions/react-button";
import { Checkbox } from "@wise-emotions/react-checkbox";
import { FieldErrors, useForm } from "react-hook-form";
import { Input } from "@wise-emotions/react-input";
import { Select, SelectOption } from "@wise-emotions/react-select";
import { isProdDomain } from "utilities/utils";
import { parse as parseQs } from "qs";
import { useUpdateModal } from "utilities/ModalProvider";
import Loader from "components/Loader";
import Modal from "components/Modal";
import React, { useState } from "react";
import axios, { AxiosResponse } from "axios";
import parse from "html-react-parser";

const optionsDays: SelectOption[] = [
  {
    label: "Lunedì",
    value: "Lunedì",
  },
  {
    label: "Martedì",
    value: "Martedì",
  },
  {
    label: "Mercoledi",
    value: "Mercoledì",
  },
  {
    label: "Giovedì",
    value: "Giovedì",
  },
  {
    label: "Venerdì",
    value: "Venerdì",
  },
];
const optionsHours: SelectOption[] = [
  {
    label: "Dalle 9.00 alle 13.00",
    value: "9-13",
  },
  {
    label: "Dalle 14.00 alle 19.00",
    value: "14-19",
  },
  {
    label: "Tutta la giornata",
    value: "tutta la giornata",
  },
];

const optionsTopics: SelectOption[] = [
  {
    label: "Sottoscrizione contratto",
    value: "sottoscrizione contratto",
  },
  {
    label: "Informazioni generali",
    value: "informazioni generali",
  },
];

const optionsEmployeesSME: SelectOption[] = [
  {
    label: "1",
    value: "01",
  },
  {
    label: "Da 2 a 4",
    value: "02",
  },
  {
    label: "Da 5 a 9",
    value: "03",
  },
  {
    label: "Da 10 a 49",
    value: "04",
  },
  {
    label: "Da 50 a 149",
    value: "05",
  },
];

const optionsEmployeesTOP: SelectOption[] = [
  {
    label: "Da 150 a 500",
    value: "07",
  },
  {
    label: "Da 501 a 1000",
    value: "08",
  },
  {
    label: "Da 1001 a 5000",
    value: "09",
  },
  {
    label: "Oltre 5000",
    value: "10",
  },
];

const optionsRevenue: SelectOption[] = [
  {
    label: "Nessun Fatturato",
    value: "01",
  },
  {
    label: "Fino a 100.000",
    value: "02",
  },
  {
    label: "Da 100.000 a 250.000",
    value: "03",
  },
  {
    label: "Da 250.000 a 500.000",
    value: "04",
  },
  {
    label: "Da 500.000 a 1.500.000",
    value: "05",
  },
  {
    label: "Da 1.500.000 a 3.000.000",
    value: "06",
  },
  {
    label: "Da 3.000.000 a 5.000.000",
    value: "07",
  },
  {
    label: "Da 5.000.000 a 50.000.000",
    value: "08",
  },
];

// NOTE: Attend api
// const SELECTS = {
//   DAY: [],
//   HOURS: [],
//   TOPIC: [],
//   YEAR_REVENUE: [],
//   EMPLOYEE_COUNTER_CODE: [],
// };

// const LIST_SELECT_KEY: ListSelectKeyArray = [
//   // "DAY",
//   // "HOURS",
//   // "TOPIC",
//   "EMPLOYEE_COUNTER_CODE",
//   "YEAR_REVENUE",
// ];

// type ListOptions = {
//   [K in (typeof LIST_SELECT_KEY)[number]]: NormalizedSelectOption[];
// };

// const API_OPTIONS =
//   "https://dynamic-mock-dev.wisetools.it/b2b/data-registry-code/";

const FromBusiness = ({
  classForm,
  slug,
  labelBtnSubmit,
  defaultErrorMessage,
  defaultSuccessMessage,
  translations,
  type,
  hiddenFields,
  ...props
}: FormCustomBusinessProps) => {
  const modalFormId = `modal-form-${slug}`;
  const isFreelance = "isFreelance" in props ? !!props.isFreelance : false;

  const formMethods = useForm<ReactHookFormSME | ReactHookFormTOP>({
    defaultValues: {
      ClientType: type,
      PrivacyFlag: false,
    },
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
  } = formMethods;

  const values = getValues();

  const { openModal, closeModal } = useUpdateModal();
  const [loader, setLoader] = useState(false);
  const [responseMessage, setResponseMessage] = useState<FormResponse>({
    message: "",
    result: "error",
  });

  const onChange = (
    slugName: keyof (Omit<FormSME, "ClientType"> & Omit<FormTOP, "ClientType">),
    value: string,
  ) => {
    setValue(slugName, value);
  };

  const checkError = (error: ApiResponse) => {
    switch (error.errorCode) {
      case "01":
        setResponseMessage({ message: defaultErrorMessage, result: "error" });
        break;

      case "06":
        setResponseMessage({
          message: translations["form-error-generic-error"],
          result: "error",
        });
        break;
      case "90":
        setResponseMessage({
          message: translations["form-error-generic-error"],
          result: "error",
        });
        break;
      case "99":
        setResponseMessage({
          message: translations["form-error-generic-error"],
          result: "error",
        });
        break;

      default:
        setResponseMessage({ message: defaultErrorMessage, result: "error" });
        break;
    }
  };

  const onSubmit = (formValues: ReactHookFormSME | ReactHookFormTOP) => {
    const data: FormSME | FormTOP = {
      ...formValues,
      PrivacyFlag: formValues.PrivacyFlag.toString(),
    };

    // NOTE: business requested to auto compile the field LeadCompanyName with the value of FirstName and LastName and EmployeeCode with "01" (only 1 employee, the freelancer)
    if (isFreelance) {
      data.LeadCompanyName = `${formValues.FirstName} ${formValues.LastName}`;
      data.EmployeeCode = optionsEmployeesSME[0].value;
    }

    data.FormSource = "Sito Web";
    data.LeadSource = "Form";
    data.Status = "Open-Active";
    data.Stage = "Assigned";
    data.SystemCaller = "Sito Pubblico";
    if (typeof window !== "undefined" && window.location.search) {
      const obj = parseQs(window.location.search, { ignoreQueryPrefix: true });
      const { utm_campaign, utm_medium, utm_source } = obj;
      if (utm_campaign || utm_medium || utm_source) {
        data.Campaign = `${utm_campaign || ""},${utm_medium || ""},${
          utm_source || ""
        }`;
      }
    }

    const domain = isProdDomain()
      ? process.env.GATSBY_APIGEEX
      : process.env.GATSBY_APIGEEX_TEST;

    const FORM_API = `${domain}/tlp-pega/prweb/api/TBusiness/1/POST/CreateLead`;

    setLoader(true);

    axios
      .post(FORM_API, data)

      .then((res: AxiosResponse<ApiResponse>) => {
        setLoader(false);
        if (res.data.errorCode === "0") {
          setResponseMessage({
            message: defaultSuccessMessage,
            result: "success",
          });
        } else {
          checkError(res.data);
        }

        if (openModal) {
          openModal(modalFormId);
        }
        const { dataLayer } = window as any;
        if (dataLayer) {
          dataLayer.push({
            event: `form_b2b_${type}_submit`,
          });
        }
        reset();
      })
      .catch((error) => {
        setLoader(false);

        setResponseMessage({ message: defaultErrorMessage, result: "error" });

        if (openModal) {
          openModal(modalFormId);
        }
      });
  };

  const classField = "FormField";

  const valitadionTax = (error: FieldErrors) => {
    if (error.PIVA?.type === "required") {
      return translations["form-error-field-required"];
    }

    return translations["form-error-input-piva-format"];
  };

  // NOTE: get value of select from API, enabled when the apis is done
  // const [dataOtipions, setDataOtipions] = useState<ListOptions>(SELECTS);
  // useEffect(() => {
  //   const getSelects = async () => {
  //     await asyncForEach(LIST_SELECT_KEY, async (key: keyof ListOptions) => {
  //       axios
  //         .get(`${API_OPTIONS}${key}`)
  //         .then((res) => {
  //           const n = buildSelectOptions(res.data);
  //           // dataOtipions[key] = n;
  //           setDataOtipions((prevState) => ({
  //             ...prevState,
  //             [key]: n,
  //           }));
  //           // setDataOtipions(dataOtipions[key].push(n));
  //         })
  //         .catch((error) => {
  //           setLoader(false);
  //           setResponseMessage({
  //             message: defaultErrorMessage,
  //             result: "error",
  //           });
  //           if (openModal) {
  //             openModal(modalFormId);
  //           }
  //         });
  //     });
  //   };
  //   getSelects();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} id={slug} className={classForm}>
        {loader && <Loader loading={loader} full />}
        <fieldset className={classField}>
          <Input
            label={translations["form-field-firstname-label"]}
            id={`${slug}-firstname`}
            helperText={errors.FirstName ? errors.FirstName.message : ""}
            valid={!errors.FirstName}
            {...register("FirstName", {
              required: translations["form-error-field-required"],
            })}
          />
        </fieldset>

        <fieldset className={classField}>
          <Input
            label={translations["form-field-lastname-label"]}
            id={`${slug}-lastname`}
            helperText={errors.LastName ? errors.LastName.message : ""}
            valid={!errors.LastName}
            {...register("LastName", {
              required: translations["form-error-field-required"],
            })}
          />
        </fieldset>
        <fieldset className={classField}>
          <Input
            label={translations["form-field-email-label"]}
            id={`${slug}-email`}
            helperText={errors.OtherEmail ? errors.OtherEmail.message : ""}
            valid={!errors.OtherEmail}
            {...register("OtherEmail", {
              required: translations["form-error-field-required"],
              pattern: {
                value:
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: translations["form-error-input-email-format"],
              },
            })}
          />
        </fieldset>

        <fieldset className={classField}>
          <Input
            label={
              values.ClientType === "SME"
                ? translations["form-field-phonenumber-label-required"]
                : translations["form-field-phonenumber-label"]
            }
            id={`${slug}-phonenumber`}
            helperText={
              errors.ContactPhoneNumber ? errors.ContactPhoneNumber.message : ""
            }
            valid={!errors.ContactPhoneNumber}
            {...register("ContactPhoneNumber", {
              required:
                values.ClientType === "SME"
                  ? translations["form-error-field-required"]
                  : false,
            })}
          />
        </fieldset>

        {!hiddenFields.includes("DayAvailability") && (
          <fieldset className={classField}>
            <Select
              id={`${slug}-dayavailability`}
              label={translations["form-business-field-dayavailability-label"]}
              options={optionsDays}
              helperText={
                errors.DayAvailability ? errors.DayAvailability.message : ""
              }
              valid={!errors.DayAvailability}
              value={values.DayAvailability}
              {...register("DayAvailability")}
              onChange={(e, value) => {
                onChange("DayAvailability", value);
              }}
            />
          </fieldset>
        )}
        {!hiddenFields.includes("HourAvailability") && (
          <fieldset className={classField}>
            <Select
              id={`${slug}-houravailability`}
              label={translations["form-business-field-houravailability-label"]}
              options={optionsHours}
              helperText={
                errors.HourAvailability ? errors.HourAvailability.message : ""
              }
              valid={!errors.HourAvailability}
              value={values.HourAvailability}
              {...register("HourAvailability")}
              onChange={(e, value) => {
                onChange("HourAvailability", value);
              }}
            />
          </fieldset>
        )}

        {!hiddenFields.includes("Topic") && (
          <fieldset className={classField}>
            <Select
              id={`${slug}-topic`}
              label={translations["form-business-field-topic-label"]}
              options={optionsTopics}
              helperText={errors.Topic ? errors.Topic.message : ""}
              valid={!errors.Topic}
              value={values.Topic}
              {...register("Topic")}
              onChange={(e, value) => {
                onChange("Topic", value);
              }}
            />
          </fieldset>
        )}

        <fieldset className={classField}>
          <Input
            label={translations["form-field-piva-label"]}
            id={`${slug}-tax`}
            valid={!errors.PIVA}
            helperText={errors.PIVA ? valitadionTax(errors) : ""}
            {...register("PIVA", {
              required: true,
              pattern: /^[A-Z0-9]*$/,
              validate: (value) => {
                return value.length === 11;
              },
            })}
          />
        </fieldset>

        {!isFreelance && (
          <>
            <fieldset className={classField}>
              <Input
                label={translations["form-business-field-companyname-label"]}
                id={`${slug}-companyname`}
                helperText={
                  errors.LeadCompanyName ? errors.LeadCompanyName.message : ""
                }
                valid={!errors.LeadCompanyName}
                {...register("LeadCompanyName", {
                  required: translations["form-error-field-required"],
                })}
              />
            </fieldset>
            <fieldset className={classField}>
              <Select
                id={`${slug}-employeecode`}
                label={translations["form-business-field-employeecode-label"]}
                options={
                  values.ClientType === "SME"
                    ? optionsEmployeesSME
                    : optionsEmployeesTOP
                }
                helperText={
                  errors.EmployeeCode ? errors.EmployeeCode.message : ""
                }
                valid={!errors.EmployeeCode}
                value={values.EmployeeCode}
                {...register("EmployeeCode", {
                  required: translations["form-error-field-required"],
                })}
                onChange={(e, value) => {
                  onChange("EmployeeCode", value);
                }}
              />
            </fieldset>
          </>
        )}

        {values.ClientType === "SME" &&
          !hiddenFields.includes("RevenueCode") && (
            <fieldset className={classField}>
              <Select
                id={`${slug}-revenue`}
                label={translations["form-business-field-revenuecode-label"]}
                options={optionsRevenue}
                value={values.RevenueCode}
                {...register("RevenueCode")}
                onChange={(e, value) => {
                  onChange("RevenueCode", value);
                }}
              />
            </fieldset>
          )}

        {!hiddenFields.includes("PromoCode") && (
          <fieldset className={classField}>
            <Input
              label={translations["form-business-field-promocode-label"]}
              id={`${slug}-promocode`}
              {...register("PromoCode")}
            />
          </fieldset>
        )}

        <fieldset className={classField}>
          <Checkbox
            id={`${slug}-privacy`}
            label={
              translations["form-business-field-privacy-label"]
                ? parse(translations["form-business-field-privacy-label"])
                : ""
            }
            valid={!errors.PrivacyFlag}
            {...register("PrivacyFlag", { required: true })}
          />
        </fieldset>

        <div className="form-custom-dynamic-fields__actions">
          <Button variant="default" type="submit" size="lg">
            {labelBtnSubmit}
          </Button>
        </div>
      </form>

      <Modal id={modalFormId} modalType="medium">
        <div className={styles.business__fromResponse}>
          <div className={styles.business__fromResponseIcon}>
            {responseMessage.result === "success" ? (
              <img src="/animation_success.gif" alt="succes" />
            ) : (
              <img src="/animation_error.gif" alt="error" />
            )}
          </div>
          <div className={styles.business__fromResponseText}>
            {parse(responseMessage.message)}
          </div>
        </div>
      </Modal>
    </>
  );
};
export default FromBusiness;
